import React from 'react';
import history from "../../../routes/history";
import contractjobIcon from '../../../assets/img/contract_job.png'
import permanentjobIcon from '../../../assets/img/permanent_job.png'
import './JobType.css'
import { Row, Col, Rate, Input } from "antd";

export default function JobType() {
  const profileSuccess = () => {
    history.push({ pathname: '/allset' })
  }
  return (

    <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: "100vh", 
    // background: 'pink'
     }}>
      <Col xs={22} sm={22} lg={10} xl={10}
        style={{ background: 'yellow', marginBottom: '12%' }}
      >
        <div className="jobPage" >

          <div >
            <div className="jobType-Header">Post a gig</div>
            <div className="jobType-desc"> Post a gig your hiring for. List your ideal candidate’s skills to get matched with the best talent for the gig.
            </div>
          </div>


          <div className='jobType-select'>Choose the gig type</div>

          <div className="jobType-chooseJob">
            <Col style={{width: '48%'}}>
              <div className="contractJob" onClick={profileSuccess} >
                <img src={contractjobIcon} alt="contractjobIcon" className='jobIcon'
                />
                <div className="jobDivider"></div>
                <div className="jobText">Contract</div>
              </div>
            </Col>
            <Col style={{width: '48%'}}>
              <div className="permanentJob" >
                <img src={permanentjobIcon} alt="permanentjobIcon" className='jobIcon' onClick={profileSuccess} />
                <div className="jobDivider"></div>
                <div className="jobText">Permanent</div>
              </div>
            </Col>
          </div>

          <div className='JobType-later'>Skip, I’ll post a gig later</div>

        </div>
      </Col>
    </Row>

  );
}
